// extracted by mini-css-extract-plugin
module.exports =  {"resetMargin":"resetMargin__WMgdg","preserveDaysBlock":"preserveDaysBlock__Td8r9"};